import { type ReactNode, useMemo } from 'react';

import { useCardOfferContext } from '@/microfrontends/listing/shared/context/selectors';

import { GalleryLayout } from '../components/GalleryLayout';
import { Thumbnails } from '../components/Thumbnails';

import { SliderAddonsContainer } from './SliderAddonsContainer';
import { SliderContainer } from './SliderContainer';

export function GalleryContainer(): ReactNode {
  const {
    data: {
      media: { thumbnails, photos },
      extendedProperties: { offerServices },
    },
  } = useCardOfferContext();

  const thumbnailsElement = useMemo((): JSX.Element | undefined => {
    if (offerServices?.isTop3) {
      return <Thumbnails hasMore={photos.length > 4} thumbnails={thumbnails} />;
    }

    return undefined;
  }, [offerServices?.isTop3, photos, thumbnails]);

  return (
    <GalleryLayout
      slider={<SliderContainer />}
      sliderAddons={<SliderAddonsContainer />}
      thumbnails={thumbnailsElement}
    />
  );
}
